import React from "react";

export const ChartContainerMessage = ({ message }) => {
	const _message = Array.isArray(message)
		? message
		: [message || "Something went wrong"];
	return (
		<div className={""}>
			{_message.map((m, index) => {
				return (
					<p
						key={`ccm_${index}`}
						className={"w-full text-center p-4 text-xs sm:text-sm"}
					>
						{m}
					</p>
				);
			})}
		</div>
	);
};
